import React, { useState } from 'react';

import { IconButton, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PersonOutlined, Block, BusinessOutlined, AssessmentOutlined, EmailOutlined, CheckCircle, Email, MoreVert, PhoneOutlined, AccessTime } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

import { ROLES } from '../../constants/general';
import { useAppContext } from '../../contexts/AppContext';

const useStyles = makeStyles((theme) => ({
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  menuSeparator: {
    backgroundColor: '#E7E7E7',
    border: 'none',
    height: '1px',
    margin: '0 8px',
  },
  resendIcon: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(1),
  },
}));

const UserActionsMenu = ({ user, status, onResendInvitation, onChangeUserStatus, onUpdateUser }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();
  const { currentUser } = useAppContext();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleResendInvitation = () => {
    handleCloseMenu();
    onResendInvitation(user);
  };

  const handleAction = (action) => {
    handleCloseMenu();
    onChangeUserStatus(user, action);
  };

  const openTechnologistReportPage = () => {
    handleCloseMenu();
    history.push(`/technologist-summary/${user.id}`);
  };

  const handleUpdateUser = (updateType) => {
    handleCloseMenu();
    onUpdateUser(user, updateType);
  };

  return (
    <>
      <Tooltip title="User actions">
        <IconButton className={classes.actionButton} size="small" onClick={handleOpenMenu}>
          <MoreVert fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
        PaperProps={{
          style: {
            backgroundColor: 'white',
            border: '1px solid #E7E7E7',
            borderRadius: '8px',
            boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
          },
        }}>
        {status === 'Active' && (
          <MenuItem onClick={openTechnologistReportPage}>
            <AssessmentOutlined fontSize="small" style={{ marginRight: 8 }} />
            See Report
          </MenuItem>
        )}

        {status === 'Invited' && (
          <MenuItem onClick={handleResendInvitation}>
            <Email fontSize="small" style={{ marginRight: 8 }} />
            Resend Invitation
          </MenuItem>
        )}

        <hr className={classes.menuSeparator} />

        {[ROLES.ADMIN.role, ROLES.LEAD_TECH.role].includes(currentUser?.role) && (
          <MenuItem onClick={() => handleUpdateUser('role')}>
            <PersonOutlined fontSize="small" style={{ marginRight: 8 }} />
            Role
          </MenuItem>
        )}

        {[ROLES.ADMIN.role].includes(currentUser?.role) && (
          <MenuItem onClick={() => handleUpdateUser('facility')}>
            <BusinessOutlined fontSize="small" style={{ marginRight: 8 }} />
            Facility
          </MenuItem>
        )}

        {[ROLES.ADMIN.role].includes(currentUser?.role) && (
          <MenuItem onClick={() => handleUpdateUser('phone')}>
            <PhoneOutlined fontSize="small" style={{ marginRight: 8 }} />
            Phone
          </MenuItem>
        )}

        {[ROLES.ADMIN.role, ROLES.LEAD_TECH.role].includes(currentUser?.role) && user.role === ROLES.RADIOLOGIST.role && (
          <MenuItem onClick={() => handleUpdateUser('modalities')}>
            <EmailOutlined fontSize="small" style={{ marginRight: 8 }} />
            Modality Filters
          </MenuItem>
        )}

        {[ROLES.ADMIN.role, ROLES.LEAD_TECH.role].includes(currentUser?.role) && user.role === ROLES.TECHNOLOGIST.role && (
          <MenuItem onClick={() => handleUpdateUser('modality')}>
            <EmailOutlined fontSize="small" style={{ marginRight: 8 }} />
            Modality
          </MenuItem>
        )}

        {[ROLES.ADMIN.role, ROLES.LEAD_TECH.role].includes(currentUser?.role) && (
          <MenuItem onClick={() => handleUpdateUser('fte')}>
            <AccessTime fontSize="small" style={{ marginRight: 8 }} />
            FTE
          </MenuItem>
        )}

        {currentUser?.role === ROLES.ADMIN.role && (
          <>
            {status !== 'Invited' && <hr className={classes.menuSeparator} />}

            {status === 'Active' && (
              <MenuItem onClick={() => handleAction('disable')}>
                <Block fontSize="small" style={{ marginRight: 8 }} />
                Disable User
              </MenuItem>
            )}

            {status === 'Disabled' && (
              <MenuItem onClick={() => handleAction('enable')}>
                <CheckCircle fontSize="small" style={{ marginRight: 8 }} />
                Enable User
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </>
  );
};

export default UserActionsMenu;
